import { createFileRoute, Navigate } from '@tanstack/react-router';

/**
 * Rota legada: o calendário Google foi consolidado em "Calendário de Captações".
 * Mantida para favoritos; redireciona para a nova página.
 */
export const Route = createFileRoute('/_authenticated/calendar')({
  component: CalendarRedirect,
});

function CalendarRedirect() {
  return <Navigate to="/calendar-captations" replace />;
}
